import FileSaver from 'file-saver';

export default function download(url, filename) {
  const authToken = localStorage.getItem('authToken');
  const headers = authToken ? { Authorization: authToken } : {};
  return fetch(url, { method: 'GET', headers })
    .then((res) => {
      if (!res.ok) {
        throw new Error(res.statusText);
      }
      return res.blob();
    })
    .then((blob) => {
      FileSaver.saveAs(blob, filename);
    });
}
